import { Col, Divider, Row } from "antd";
import React from "react";
import { CustomLabel } from "../../../Constant";
import FooterButton from "../../Footer";

const ContentComponent = ({
  label,
  value,
  isMobileNumber = false,
  showOtp,
  showProceedBtn,
  onAPiCall = () => {},
  disableNext = false,
}) => {
  return (
    <div>
      <Row justify="space-between">
        <Col span={10}>
          <CustomLabel>{label}</CustomLabel>
        </Col>
        <Col span={10}>
          <div className="">
            <CustomLabel font_weight="normal">
              {value}
            </CustomLabel>
          </div>
        </Col>
        {isMobileNumber && (
          <>
            <Col span={10}></Col>
            {showProceedBtn && (
              <Col span={10}>
                <FooterButton
                  hideBack={true}
                  nextLabel={showOtp ? "Resend OTP" : "Send OTP"}
                  onNext={onAPiCall}
                  disableNext={disableNext}
                />
              </Col>
            )}
          </>
        )}
        <Divider />
      </Row>
    </div>
  );
};

export default ContentComponent;
